import { render, staticRenderFns } from "./NormalAlert.vue?vue&type=template&id=28267732&scoped=true"
import script from "./NormalAlert.vue?vue&type=script&lang=js"
export * from "./NormalAlert.vue?vue&type=script&lang=js"
import style0 from "./NormalAlert.vue?vue&type=style&index=0&id=28267732&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28267732",
  null
  
)

export default component.exports